import React, { Component } from "react";
import { connect } from "react-redux";
import { func, instanceOf } from "prop-types";
// import { saveAs } from 'file-saver';

import BlobPreview from "../BlobPreview";
import { blobToBase64 } from "../../logic/blobToBase64";
// import { isAndroid } from "../../logic/deviceType";
import PageContent from "../PageContent";
import { retry } from "../../logic/actions/faceCapture";
import { go } from "../../logic/actions/navigation";
import { faceSave } from "../../logic/actions/api/face";
import "./style.css";
import {
  logEvent,
  FACE_CAPTURE_RETRY,
  STEP_COMPLETED,
} from "../../logic/eventLogger";
import { VERIFY_IDENTITY } from "../../logic/enums/pages";
import { CONNECTION_ISSUES } from "../../logic/enums/errorMessages";

export class PageFaceCaptureConfirm extends Component {
  static propTypes = {
    retry: func,
    faceSave: func,
    go: func,
    blob: instanceOf(Blob),
  };

  constructor(props) {
    super(props);
    this.state = {};
    this.getBack.bind(this);
    this.submit.bind(this);
  }

  getBack = () => {
    logEvent(FACE_CAPTURE_RETRY);
    this.props.retry();
  };

  componentDidMount() {
    const wrapperDiv = document.getElementById("wrapperDiv");
    this.setState({
      width: wrapperDiv.offsetWidth,
      height: wrapperDiv.offsetHeight,
    });
  }

  submit = () => {
    this.setState({ pending: true, error: false });
    blobToBase64(this.props.blob)
      .then((data) => {
        this.props
          .faceSave(data)
          .then(() => {
            logEvent(STEP_COMPLETED, { value: "face_capture" });
            logEvent(STEP_COMPLETED + "_face_capture");
            this.props.go(VERIFY_IDENTITY);
          })
          .catch(() => {
            this.setState({
              error: CONNECTION_ISSUES,
              pending: false,
            });
          });
      })
      .catch(() => {
        this.setState({ error: "Failed to convert image", pending: false });
      });
  };
  render() {
    // saveAs(this.props.blob, "selfie-img.jpg");
    const isActive = this.state.pending && !this.state.error;
    const classNameBtn = this.state.pending ? "btn gray" : "btn blue";
    const text = this.props.isRejected
      ? "Please retake a selife."
      : "Are you happy with the image or would you like to retake the photo?";
    const panelClassName =
      this.props.captureMethod === "NATIVE"
        ? "panel border-gray bg-row flip-x"
        : "panel border-gray bg-row";
    // const blobPreviewClassName = "img-preview";
    // const blobPreviewClassName = (isAndroid(navigator.userAgent) && this.props.captureMethod === "NATIVE")
    //   ? "img-preview rotate-mobile-native " : (this.props.captureMethod === "WEBRTC")
    //     ? "img-preview flip-x" : "img-preview";
    return (
      <PageContent
        toggleLoading={isActive}
        progressBar={true}
        progressPercentage={50}
      >
        <h1>Selfie</h1>
        <p className="center">{text}</p>
        <div
          id="wrapperDiv"
          className={panelClassName}
          style={{ height: "45vh" }}
        >
          <BlobPreview
            width={this.state.width}
            height={this.state.height}
            flipX={true}
            blob={this.props.blob}
          />
        </div>
        <p className="error">{this.state.error}</p>

        {this.props.isRejected ? (
          <div className="message-box-error">
            {this.props.message}
            <button
              disabled={this.state.pending}
              className="btn white"
              onClick={this.getBack}
            >
              Retake the photo
            </button>
          </div>
        ) : (
          <div className="row row-justify-space">
            <button
              disabled={this.state.pending}
              className="btn white"
              onClick={this.getBack}
            >
              Retake the photo
            </button>
            <button
              disabled={this.state.pending}
              className={classNameBtn}
              onClick={this.submit}
            >
              Continue
            </button>
          </div>
        )}
      </PageContent>
    );
  }
}

export default connect(
  (state) => {
    return { ...state.faceCapture };
  },
  { faceSave, retry, go }
)(PageFaceCaptureConfirm);
